import { cacheDom } from "../utils/QuerySelectors.js"
import { makeLineItem, addLineItems } from "../utils/Cart.js"

const dom = {};
const qs = {}
const qsAll = {
  btns: 'data-inline-product-add',
}

export const setupInlineProductAddButtons = () => {
  cacheDom(dom, qs, qsAll)
  dom.btns.forEach(btn => {
    btn.addEventListener('click', () => {
      const productData = JSON.parse(btn.dataset.product)
      const variantId = btn.dataset.variantId
      const items = [makeLineItem(variantId, 1, productData.tags)]
      addLineItems(null, items, true, btn)
      btn.disabled = true
    })
  })
}